import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-access-request" },
    [
      !_vm.tplToWork ? _c("p", [_vm._v("Template not found!")]) : _vm._e(),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": true,
          "is-full-page": true,
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        VRow,
        { attrs: { dense: "" } },
        [
          _c(VCol, { staticClass: "mb-2", attrs: { sm: "12" } }, [
            _c("label", { staticClass: "subtitle-1" }, [
              _vm._v(
                "Table: " +
                  _vm._s(
                    _vm._f("joinTableReference")(
                      _vm.tplToWork.item.tableReference
                    )
                  )
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm.tplToWork && _vm.defaultFields
        ? _c(
            VForm,
            {
              ref: "form",
              staticClass: "form",
              attrs: { "lazy-validation": "" },
              on: { submit: _vm.onSubmit },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _vm.tplToWork.item.created
                    ? _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "p-0 font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("my_tasks.modals.request_since"))
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VIcon,
                                              _vm._g(
                                                _vm._b(
                                                  { attrs: { small: "" } },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v("icon-help")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3683083857
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v("Initial date for the request"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tplToWork.item.created
                    ? _c(
                        VCol,
                        { staticClass: "col-md-4" },
                        [
                          _c(VTextField, {
                            attrs: {
                              small: "",
                              dense: "",
                              outlined: !(this.tplToWork.tipo === "vista"),
                              filled: _vm.tplToWork.tipo === "vista",
                              readonly: _vm.tplToWork.tipo === "vista",
                              type: "date",
                            },
                            model: {
                              value: _vm.tplToWork.item.created,
                              callback: function ($$v) {
                                _vm.$set(_vm.tplToWork.item, "created", $$v)
                              },
                              expression: "tplToWork.item.created",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    { staticClass: "col-md-2" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "p-0 font-weight-bold" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("my_tasks.modals.request_until"))
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VIcon,
                                          _vm._g(
                                            _vm._b(
                                              { attrs: { small: "" } },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("icon-help")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3683083857
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v("Fecha límite para la solicitud"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-4" },
                    [
                      _vm.tplToWork.tipo == "vista"
                        ? [
                            _c(VTextField, {
                              attrs: {
                                small: "",
                                dense: "",
                                type: "date",
                                outlined: !(this.tplToWork.tipo === "vista"),
                                filled: _vm.tplToWork.tipo === "vista",
                                readonly: _vm.tplToWork.tipo === "vista",
                              },
                              model: {
                                value: _vm.tplToWork.item.endDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tplToWork.item, "endDate", $$v)
                                },
                                expression: "tplToWork.item.endDate",
                              },
                            }),
                          ]
                        : [
                            _c(
                              VMenu,
                              {
                                attrs: {
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "max-width": "290px",
                                  "min-width": "290px",
                                  "close-on-content-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VTextField,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    rules: _vm.rules.endDate,
                                                    "append-icon": "event",
                                                    readonly: "",
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "auto",
                                                    placeholder: "YYYY-MM-DD",
                                                  },
                                                  on: {
                                                    "click:append": on.click,
                                                  },
                                                  model: {
                                                    value: _vm.toSave.endDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.toSave,
                                                        "endDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toSave.endDate",
                                                  },
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3640404501
                                ),
                                model: {
                                  value: _vm.menu_calendar,
                                  callback: function ($$v) {
                                    _vm.menu_calendar = $$v
                                  },
                                  expression: "menu_calendar",
                                },
                              },
                              [
                                _c(VDatePicker, {
                                  attrs: { scrollabel: "" },
                                  on: {
                                    input: function ($event) {
                                      _vm.menu_calendar = false
                                    },
                                  },
                                  model: {
                                    value: _vm.toSave.endDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.toSave, "endDate", $$v)
                                    },
                                    expression: "toSave.endDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                VRow,
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tplToWork.tipo != "vista",
                      expression: "tplToWork.tipo !='vista'",
                    },
                  ],
                  attrs: { dense: "" },
                },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-2" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "p-0 font-weight-bold" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("my_tasks.modals.external_user"))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-4" },
                    [
                      _c(VCheckbox, {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.right",
                            value: "Set external user",
                            expression: "'Set external user'",
                            modifiers: { hover: true, right: true },
                          },
                        ],
                        attrs: {
                          id: "checkbox-service-account",
                          name: "checkbox-service-account",
                          disabled:
                            _vm.tplToWork.tipo === "vista" ||
                            _vm.isAudience ||
                            _vm.isAttributes ||
                            _vm.isProductivize,
                          dense: "",
                          small: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeExternalUser()
                          },
                        },
                        model: {
                          value: _vm.isExternalUser,
                          callback: function ($$v) {
                            _vm.isExternalUser = $$v
                          },
                          expression: "isExternalUser",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _vm.isExternalUser
                    ? [
                        _c(
                          VCol,
                          { staticClass: "col-md-2" },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "p-0 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.modals.user_type"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "col-md-4" },
                          [
                            _vm.tplToWork.tipo === "vista"
                              ? _c(VTextField, {
                                  attrs: {
                                    small: "",
                                    dense: "",
                                    filled: "",
                                    value: _vm.isServiceAccount
                                      ? "Service Account"
                                      : "External User",
                                    readonly: "",
                                  },
                                })
                              : _c(VSelect, {
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    small: "",
                                    items: _vm.tplToWork.item.isSynapse
                                      ? _vm.externalUserSynapse
                                      : _vm.filteredExternalUserOptions,
                                    rules: _vm.rules.externalUserType,
                                    disabled:
                                      _vm.tplToWork.tipo === "vista" ||
                                      _vm.isAudience ||
                                      _vm.isAttributes ||
                                      _vm.isProductivize,
                                  },
                                  on: { change: _vm.onSelectUserType },
                                  model: {
                                    value: _vm.externalUserType,
                                    callback: function ($$v) {
                                      _vm.externalUserType = $$v
                                    },
                                    expression: "externalUserType",
                                  },
                                }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.isExternalUser &&
                  _vm.externalUserType != 3 &&
                  _vm.externalUserType !== 4 &&
                  _vm.externalUserType !== 5 &&
                  _vm.externalUserType !== 6
                    ? [
                        _c(
                          VCol,
                          { staticClass: "col-md-2" },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "p-0 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.modals.client_email"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { staticClass: "col-md-4" },
                          [
                            _c(VTextField, {
                              attrs: {
                                dense: "",
                                small: "",
                                outlined: !(this.tplToWork.tipo === "vista"),
                                filled: _vm.tplToWork.tipo === "vista",
                                type: "text",
                                rules: _vm.tplToWork.item.isSynapse
                                  ? []
                                  : _vm.rules.clientEmail,
                                readonly: _vm.tplToWork.tipo === "vista",
                              },
                              model: {
                                value: _vm.benefited,
                                callback: function ($$v) {
                                  _vm.benefited = $$v
                                },
                                expression: "benefited",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.isExternalUser
                ? _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "p-0 font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("my_tasks.modals.use_case")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-10" },
                        [
                          _vm.isExternalUser &&
                          (_vm.externalUserType == 4 ||
                            _vm.externalUserType == 5)
                            ? _c(VAutocomplete, {
                                attrs: {
                                  dense: "",
                                  small: "",
                                  outlined: !(this.tplToWork.tipo === "vista"),
                                  filled: _vm.tplToWork.tipo === "vista",
                                  readonly: _vm.tplToWork.tipo === "vista",
                                  label: "Sandbox",
                                  items: _vm.sandboxes,
                                  "item-text": "name",
                                  rules: _vm.rules.useCase,
                                  "return-object": "",
                                },
                                model: {
                                  value: _vm.sandbox,
                                  callback: function ($$v) {
                                    _vm.sandbox = $$v
                                  },
                                  expression: "sandbox",
                                },
                              })
                            : _vm._e(),
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              small: "",
                              outlined: !(this.tplToWork.tipo === "vista"),
                              filled: _vm.tplToWork.tipo === "vista",
                              readonly: _vm.tplToWork.tipo === "vista",
                              type: "text",
                              placeholder: _vm.$t("my_tasks.modals.why_need"),
                              rules: _vm.rules.useCase,
                            },
                            model: {
                              value: _vm.businessCase,
                              callback: function ($$v) {
                                _vm.businessCase = $$v
                              },
                              expression: "businessCase",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _vm.tplToWork.tipo != "vista"
                    ? _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "p-0 font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("my_tasks.modals.attach")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tplToWork.tipo != "vista"
                    ? _c(
                        VCol,
                        { staticClass: "col-md-4" },
                        [
                          _c(
                            "b-input-group",
                            {
                              staticClass: "input-mini",
                              attrs: { size: "sm" },
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    color: "secondary",
                                    outlined: "",
                                    rounded: "",
                                    dense: "",
                                    small: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs.fileInput2.$el
                                        .querySelector("input[type=file]")
                                        .click()
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, [_vm._v("mdi-paperclip")]),
                                  _vm._v("Select a file"),
                                ],
                                1
                              ),
                              _c("b-form-file", {
                                ref: "fileInput2",
                                staticStyle: { display: "none" },
                                attrs: {
                                  accept:
                                    _vm.ACCES_REQUEST_FILE_FORMAT.join(","),
                                },
                                on: { change: _vm.onFileChange },
                                model: {
                                  value: _vm.inputUploadFile,
                                  callback: function ($$v) {
                                    _vm.inputUploadFile = $$v
                                  },
                                  expression: "inputUploadFile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    { staticClass: "col-md-6" },
                    [
                      _vm.tplToWork.tipo != "vista" &&
                      _vm.files &&
                      _vm.files.length > 0
                        ? _c(VSimpleTable, {
                            staticClass: "text-center table-inca",
                            attrs: { responsive: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("thead", [_c("tr", [_vm._v("File")])]),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.files,
                                          function (file, index) {
                                            return _c("tr", { key: index }, [
                                              _c("td", [
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openImage(
                                                          file.fileLink
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(file.fileName)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c(
                                                "td",
                                                [
                                                  _c(
                                                    VBtn,
                                                    {
                                                      staticClass:
                                                        "pointer btn-inca",
                                                      attrs: {
                                                        dense: "",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteFile(
                                                            file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [_vm._v("icon-delete")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1135240950
                            ),
                          })
                        : _vm._e(),
                      _c(
                        VAlert,
                        {
                          attrs: {
                            dismissible: "",
                            dense: "",
                            outlined: "",
                            type: "error",
                          },
                          model: {
                            value: _vm.alert,
                            callback: function ($$v) {
                              _vm.alert = $$v
                            },
                            expression: "alert",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "File format is not supported, compress it into .zip instead"
                            ),
                          ]),
                          _c(VDivider, {
                            staticClass: "my-2 info",
                            staticStyle: { opacity: "0.22" },
                          }),
                          _c(
                            VRow,
                            { attrs: { align: "center", "no-gutters": "" } },
                            [
                              _c(VProgressLinear, {
                                attrs: {
                                  value: _vm.dismissCountDown * 20,
                                  color: "error",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _vm.tplToWork.tipo !== "vista"
                    ? _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "p-0 font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("my_tasks.modals.columns_to_request")
                                ) + ":"
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tplToWork.tipo !== "vista"
                    ? _c(
                        VCol,
                        { staticClass: "col-md-4" },
                        [
                          _c(
                            VCheckbox,
                            {
                              staticClass: "m-0",
                              attrs: {
                                small: "",
                                dense: "",
                                label: _vm.$t("common.select_all"),
                                "hide-details": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onSelectAll($event)
                                },
                              },
                              model: {
                                value: _vm.select_all,
                                callback: function ($$v) {
                                  _vm.select_all = $$v
                                },
                                expression: "select_all",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.select_all")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    { staticClass: "col-md-2" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "p-0 font-weight-bold" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("my_tasks.modals.total_columns")) +
                              ":"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { key: _vm.key_total_selected, staticClass: "col-md-4" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "p-0 font-weight-bold" },
                        [_vm._v(_vm._s(_vm.getTotalSelected()))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    [
                      _vm.tplToWork.tipo == "vista"
                        ? [
                            _c("list-table-metadata-cols-component", {
                              attrs: {
                                columnFields: _vm.columnFields,
                                defaultFields: _vm.defaultFields,
                                isChangeRequest:
                                  _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                                showTitle: false,
                                isRequestView: false,
                                isOwnerApproval: false,
                                columns_selected:
                                  _vm.tplToWork.item.columns_included,
                              },
                            }),
                          ]
                        : [
                            _c("list-table-metadata-cols-component", {
                              key: _vm.key_request_table,
                              attrs: {
                                columnFields: _vm.columnFields,
                                defaultFields: _vm.defaultFields,
                                isChangeRequest:
                                  _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                                showTitle: false,
                                isRequestView: true,
                                isOwnerApproval: false,
                              },
                              on: {
                                onSelectItem: function ($event) {
                                  return _vm.onSelectItem()
                                },
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "p-0 font-weight-bold" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("my_tasks.modals.request_reason"))
                          ),
                        ]
                      ),
                      _vm.tplToWork.tipo == "vista"
                        ? [
                            _c(VTextarea, {
                              attrs: {
                                dense: "",
                                small: "",
                                outlined: !(this.tplToWork.tipo === "vista"),
                                filled: _vm.tplToWork.tipo === "vista",
                                readonly: _vm.tplToWork.tipo === "vista",
                                size: "sm",
                                rows: "3",
                                "max-rows": "3",
                                type: "text",
                              },
                              model: {
                                value: _vm.tplToWork.item.commentary,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tplToWork.item,
                                    "commentary",
                                    $$v
                                  )
                                },
                                expression: "tplToWork.item.commentary",
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _vm.tplToWork.tipo == "vista"
                        ? [
                            _c("label", [
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.response_reason"))
                                ),
                              ]),
                            ]),
                            _c(VTextarea, {
                              attrs: {
                                dense: "",
                                small: "",
                                outlined: !_vm.tplToWork.tipo === "vista",
                                filled: _vm.tplToWork.tipo === "vista",
                                readonly: _vm.tplToWork.tipo === "vista",
                                size: "lg",
                                rows: "3",
                                "max-rows": "3",
                                type: "text",
                              },
                              model: {
                                value: _vm.tplToWork.item.response,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tplToWork.item, "response", $$v)
                                },
                                expression: "tplToWork.item.response",
                              },
                            }),
                          ]
                        : [
                            _c(VTextarea, {
                              attrs: {
                                small: "",
                                dense: "",
                                outlined: "",
                                size: "lg",
                                rows: "3",
                                "max-rows": "3",
                                type: "text",
                                rules: _vm.rules.commentary,
                                placeholder: "Message...",
                              },
                              model: {
                                value: _vm.toSave.commentary,
                                callback: function ($$v) {
                                  _vm.$set(_vm.toSave, "commentary", $$v)
                                },
                                expression: "toSave.commentary",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("b", [_vm._v("Apparently the table has no associated metadata")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }